/**
 * قواعدِ سربرگِ «عکس‌ها» (WHOSUP-213) — بی‌ربط به پلتفرم، پس این‌جا و نه
 * دو بار داخلِ دو صفحه.
 *
 * همان تقسیمِ `planConfirm.ts`: تصمیم این‌جاست تا `npm test` ببیندش، و صفحه
 * فقط نتیجه را نقاشی می‌کند. هر دو اپ عیناً همین را صدا می‌زنند.
 */

/**
 * سه حالتِ ممکنِ سربرگ:
 *
 *   • `locked`  — برنامه هنوز قطعی نشده (یا لغو شده). برای هیچ‌کس باز نیست،
 *                 حتی سازنده. خواسته‌ی تیکت: «این تب بعد از کانفرم فعال میشه».
 *   • `members` — قطعی هست ولی من در جمعش نیستم. می‌بینم که هست، ولی نه
 *                 عکس‌ها را و نه دکمه‌ی فرستادن — همان قفلِ گفتگو.
 *   • `open`    — هم می‌بینم هم می‌فرستم.
 *
 * هر سه با RLS جدا هم تضمین شده‌اند (مایگریشن 0141)؛ این‌جا فقط تصمیمِ UI
 * است تا کاربر دکمه‌ای نبیند که دیتابیس ردش می‌کند.
 */
export type PhotosTabState = 'locked' | 'members' | 'open';

export function photosTabState(args: {
  /** ردیفِ `plans` وجود دارد؟ همان معیارِ «قطعی شده» در بقیه‌ی اپ. */
  hasPlan: boolean;
  isCreator: boolean;
  /** جوابِ خودم به این سیگنال؛ فقط `in` در جمع حساب می‌شود. */
  myResponse?: string | null;
  cancelled: boolean;
}): PhotosTabState {
  if (args.cancelled || !args.hasPlan) return 'locked';
  if (!args.isCreator && args.myResponse !== 'in') return 'members';
  return 'open';
}

/**
 * مسیرِ فایل در باکتِ `signal-photos`.
 *
 * ⚠ اولین بخشِ مسیر **باید** شناسه‌ی سیگنال باشد: سیاستِ storage جز نامِ
 * فایل چیزی برای تصمیم‌گیری ندارد و همین بخش را به uuid تبدیل می‌کند تا
 * بپرسد «فرستنده عضوِ این برنامه هست؟» (تابعِ `signal_photo_signal` در
 * مایگریشن 0141). شکلِ دیگری از مسیر یعنی آپلود بی‌صدا رد می‌شود.
 *
 * بخشِ تصادفی هست چون دو نفر می‌توانند در یک میلی‌ثانیه بفرستند، و `upsert`
 * عمداً خاموش است.
 */
export function signalPhotoPath(signalId: string, uid: string): string {
  const rand = Math.random().toString(36).slice(2, 8);
  return `${signalId}/${uid}-${Date.now()}-${rand}.jpg`;
}

/**
 * نامی که فایل هنگامِ **ذخیره روی دستگاه** می‌گیرد.
 *
 * آخرین بخشِ مسیر است، که از ساختِ `signalPhotoPath` یکتاست — پس دانلودِ
 * دسته‌جمعی هیچ‌وقت دو فایلِ هم‌نام نمی‌سازد و مرورگر/اندروید مجبور نیست
 * `(1)` و `(2)` بچسباند. پوشه‌ی سیگنال از اسم حذف می‌شود چون در پوشه‌ی
 * دانلودِ کاربر معنایی ندارد.
 *
 * مسیرِ بی‌اسلش (که نباید پیش بیاید) خودش نامِ فایل است، نه رشته‌ی خالی.
 */
export function photoFileName(path: string): string {
  const last = path.split('/').filter(Boolean).pop();
  return last && last.trim() ? last : 'photo.jpg';
}

/**
 * ورق زدن در نمایِ بزرگ، با چرخش.
 *
 * چرخش عمدی است: در یک آلبومِ چندتایی، رسیدن به آخر و گیر کردن حس «خراب
 * شد» می‌دهد، در حالی که برگشتن به اولی همان کاری‌ست که هر گالریِ گوشی
 * می‌کند. هر دو اپ عیناً همین را صدا می‌زنند تا سوایپِ موبایل و فلشِ وب
 * یک رفتار داشته باشند.
 *
 * فهرستِ خالی صفر می‌دهد — نمای بزرگ در آن حالت اصلاً باز نمی‌شود.
 */
export function stepPhoto(index: number, delta: number, count: number): number {
  if (count <= 0) return 0;
  return ((index + delta) % count + count) % count;
}
